const lightTheme = {
  colors: {
    darkGreen: '#2F4F4F',
    lightGreen: '#3CB371',
    brown: '#D2A46E',
    white: '#FFFFFF',
    black: '#000000',
    lightGray: '#F5F5F5',
    gray: '#666666',
    error: '#FF4444',
    success: '#4CAF50',
    background: '#FFFFFF',
    text: '#333333',
    border: '#E0E0E0'
  },
  fonts: {
    primary: 'Heebo, Assistant, sans-serif',
    secondary: 'Rubik, sans-serif',
    title: 'Karantina, cursive',
    display: 'Suez One, serif'
  },
  fontSizes: {
    tiny: '0.75rem',     // 12px
    small: '0.875rem',   // 14px
    medium: '1rem',      // 16px
    large: '1.25rem',    // 20px
    xlarge: '1.5rem',    // 24px
    huge: '2rem',        // 32px
    mega: '3rem'         // 48px
  },
  fontWeights: {
    light: 300,
    normal: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
    black: 900
  },
  lineHeights: {
    normal: 1.5,
    tight: 1.2,
    loose: 1.8
  },
  spacing: {
    tiny: '0.25rem',
    small: '0.5rem',
    medium: '1rem',
    large: '1.5rem',
    xlarge: '2rem',
    huge: '3rem',
    mega: '4rem'
  },
  breakpoints: {
    mobile: '320px',
    tablet: '768px',
    desktop: '1024px',
    wide: '1440px'
  },
  borderRadius: {
    small: '4px',
    medium: '8px',
    large: '12px',
    round: '50%'
  },
  shadows: {
    small: '0 2px 4px rgba(0, 0, 0, 0.1)',
    medium: '0 4px 8px rgba(0, 0, 0, 0.1)',
    large: '0 8px 16px rgba(0, 0, 0, 0.1)',
    xlarge: '0 12px 24px rgba(0, 0, 0, 0.1)'
  },
  transitions: {
    fast: '0.2s ease',
    medium: '0.3s ease',
    slow: '0.5s ease'
  },
  zIndices: {
    base: 0,
    dropdown: 1000,
    sticky: 1100,
    modal: 1200,
    tooltip: 1300
  },
  accessibility: {
    focusOutline: '2px solid #3CB371',
    focusRing: '0 0 0 3px rgba(60, 179, 113, 0.4)',
    skipLink: {
      background: '#2F4F4F',
      color: '#FFFFFF'
    }
  }
};

const darkTheme = {
  ...lightTheme,
  colors: {
    ...lightTheme.colors,
    darkGreen: '#4A766E',
    lightGreen: '#5DC894',
    brown: '#E5B982',
    background: '#1A1A1A',
    text: '#E0E0E0',
    lightGray: '#2A2A2A',
    gray: '#999999',
    border: '#404040'
  },
  shadows: {
    small: '0 2px 4px rgba(0, 0, 0, 0.3)',
    medium: '0 4px 8px rgba(0, 0, 0, 0.3)',
    large: '0 8px 16px rgba(0, 0, 0, 0.3)',
    xlarge: '0 12px 24px rgba(0, 0, 0, 0.3)'
  },
  accessibility: {
    ...lightTheme.accessibility,
    focusOutline: '2px solid #5DC894',
    focusRing: '0 0 0 3px rgba(93, 200, 148, 0.4)'
  }
};

export { lightTheme, darkTheme }; 